import { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorScreen } from './ui/ErrorScreen/ErrorScreen';

type AppShellErrorBoundaryProps = {
  children: ReactNode;
};

type AppShellErrorBoundaryState = {
  hasError: boolean;
};

export class AppShellErrorBoundary extends Component<
  AppShellErrorBoundaryProps,
  AppShellErrorBoundaryState
> {
  state: AppShellErrorBoundaryState = {
    hasError: false
  };

  static getDerivedStateFromError(): AppShellErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('App shell render failure', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorScreen variant="total-failure" />;
    }

    return this.props.children;
  }
}
